import angular from 'angular';
import { filter, get } from 'lodash';
const module = angular.module('whyline.directives.wlvideo', []);

const videoPlayerDirective = $timeout => {
  return {
    scope: {
      sources: '=',
      current: '='
    },
    templateUrl: '/templates/directives/video-player.html',
    link(scope, element) { // link(scope, element) {
      // Initialize cursor position
      let videoIndex = 0;
      // Get video player element
      const $el = element;
      const el = $el[0].getElementsByTagName('video')[0];
      angular.element(el).css('visibility', 'hidden');

      if (!el) return;

      const getNextVideoInQueue = () => {
        if (scope.sources.length === 0) {
          return scope.current = null;
        }

        if (scope.sources.length === 1) {
          el.setAttribute('loop', true);
        } else {
          el.removeAttribute('loop');
        }

        if (!scope.sources[videoIndex]) {
          videoIndex = 0;
        }

        scope.current = scope.sources[videoIndex];
      }

      // Handle video playback error
      function onError(e) {
        //console.log('error', e, el.networkState, scope.current);
        // Handle source error
        if (el.networkState === 3) {
          //console.log('NETWORK_NO_SOURCE');
          // Detach event listener
          el.removeEventListener('error', onError);

          angular.element(el).children('source:last').off('error', onError);

          scope.sources.splice(scope.sources.indexOf(scope.current, 1))

          getNextVideoInQueue();

          if (scope.sources.length) {
            // Re-attach event listener
            $timeout(() => {
              el.addEventListener('error', onError);
              angular.element(el).children('source:last').on('error', onError);
              el.load();
            });
          }
        }
      }

      // Listen to 'playing' event
      el.addEventListener('playing', () => {
        // When playing, increase cursor position by 1
        videoIndex++;

        getNextVideoInQueue();
      });

      // Attempt to load next video when current playback has ended
      el.addEventListener('ended', () => {
        angular.element(el).css('visibility', 'hidden');
        el.load();
      });

      el.addEventListener('error', onError);

      el.addEventListener('loadeddata', () => angular.element(el).css('visibility', 'visible'));

      getNextVideoInQueue();

      angular.element(el).children('source:last').on('error', onError);
    }
  };
};

module.exports = module.directive('wlvideo', videoPlayerDirective);
